import {
  PORTFOLIOS_CHANGED,
  PORTFOLIOS_SELECTED,
  PORTFOLIOS_LOGOUT,
  ENTIDADE_CURRENT_CHANGED
} from '../../const/actionsType';

import { dates } from 'investira.sdk';

const INITIAL_STATE = {
  data: [],
  current: {},
  updatedAt: null
};

const RESET_STATE = {
  ...INITIAL_STATE
};

function portfoliosReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case PORTFOLIOS_CHANGED:
      return {
        ...state,
        data: action.payload,
        updatedAt: dates.toDate()
      };
    case PORTFOLIOS_SELECTED:
      return {
        ...state,
        current: action.payload
      };
    case ENTIDADE_CURRENT_CHANGED:
      return {
        ...RESET_STATE
      };
    case PORTFOLIOS_LOGOUT:
      return {
        ...RESET_STATE
      };
    default:
      return state;
  }
}

export default portfoliosReducer;
